module.exports = __webpack_public_path__ + "img/full4-min.aabd9925.png";